export const GET_ADMISSION_VOUCHERS = 'GET_ADMISSION_VOUCHERS'
